import React, { Component } from 'react';
import '../loading/style.css';
import { Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';
import {Helmet} from 'react-helmet';
import PuffLoader from "react-spinners/PuffLoader";

class Loading extends Component {

  state = {
    redirect: false
  }

  componentDidMount() {
     this.id = setTimeout(() => this.setState({ redirect: true }), 3000);
    //--Faizan Noor Portfolio website Google analytics--
    //--Replace the key if needed !!
    ReactGA.initialize("UA-38523874-1");
    ReactGA.pageview('FaizanNoor.com - Loading Screen');
    //--Faizan Noor Portfolio website Google analytics--
  }
    
  componentWillUnmount() {
    clearTimeout(this.id)
  }

  render() {
    return this.state.redirect
      ? <Redirect to="/home" />
      : <div>
         <Helmet>
                <meta charSet="utf-8" />
                <title>Faizan Noor</title>
                <link rel="canonical" href="http://FaizanNoor.com/" />
                <meta name="description" content="Faizan Noor - Engineering Manager | Product Manager | Project Manager | Software Engineer" />
         </Helmet>
        <div className="Loading-header">
          <PuffLoader
            size={'40vw'}
            color={"#fff"}
            loading={true}
          />
        </div>
        </div>
  }
}

export default Loading;
